// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contacts_contacts__bG7T6 {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.Contacts_contacts__block__U1fc2 {
	padding: 6.25rem 10.31rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 5rem;
}

.Contacts_list__3aoCp {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.Contacts_list__item__Ch2GW {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: center;
	text-align: center;
}

.Contacts_item__border__hO5P5 {
	width: 0.0625rem;
	height: 12.5rem;
	flex-shrink: 0;
	background: var(--accent-color, #956446);
}

.Contacts_item__title__FaE8\\+ {
	color: var(--accent-color, #956446);

	font-family: 'Noto Sans';
	font-size: 1.375rem;
	font-style: normal;
	font-weight: 500;
	line-height: 160%; /* 2.2rem */
}

.Contacts_item__text__ZY7W2 {
	color: var(--accent-color, #956446);
	text-align: center;

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}

@media (max-width: 1280px) {
	.Contacts_contacts__block__U1fc2 {
		padding: 6.25rem 5rem;
	}
}

@media (max-width: 460px) {
	.Contacts_contacts__block__U1fc2 {
		flex-direction: column;
		padding: 4.38rem 1.25rem;
		align-items: center;
	}
	.Contacts_item__border__hO5P5 {
		display: none;
	}
	.Contacts_list__3aoCp {
		flex-wrap: wrap;
		gap: 1.3rem;
	}

	.Contacts_list__item__Ch2GW {
		width: 45%;
		align-items: center;
		height: 9.5rem;
	}
	.Contacts_item__title__FaE8\\+ {
		font-size: 1.25rem;
	}
	.Contacts_item__text__ZY7W2 {
		font-size: 0.9375rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/DefaultPage/Contacts/Contacts.module.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,cAAc;CACd,wCAAwC;AACzC;;AAEA;CACC,mCAAmC;;CAEnC,wBAAwB;CACxB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,mCAAmC;CACnC,kBAAkB;;CAElB,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;EACf,WAAW;CACZ;;CAEA;EACC,UAAU;EACV,mBAAmB;EACnB,cAAc;CACf;CACA;EACC,kBAAkB;CACnB;CACA;EACC,oBAAoB;CACrB;AACD","sourcesContent":[".contacts {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.contacts__block {\n\tpadding: 6.25rem 10.31rem;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 5rem;\n}\n\n.list {\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.list__item {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.5rem;\n\talign-items: center;\n\ttext-align: center;\n}\n\n.item__border {\n\twidth: 0.0625rem;\n\theight: 12.5rem;\n\tflex-shrink: 0;\n\tbackground: var(--accent-color, #956446);\n}\n\n.item__title {\n\tcolor: var(--accent-color, #956446);\n\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.375rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 160%; /* 2.2rem */\n}\n\n.item__text {\n\tcolor: var(--accent-color, #956446);\n\ttext-align: center;\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n\n@media (max-width: 1280px) {\n\t.contacts__block {\n\t\tpadding: 6.25rem 5rem;\n\t}\n}\n\n@media (max-width: 460px) {\n\t.contacts__block {\n\t\tflex-direction: column;\n\t\tpadding: 4.38rem 1.25rem;\n\t\talign-items: center;\n\t}\n\t.item__border {\n\t\tdisplay: none;\n\t}\n\t.list {\n\t\tflex-wrap: wrap;\n\t\tgap: 1.3rem;\n\t}\n\n\t.list__item {\n\t\twidth: 45%;\n\t\talign-items: center;\n\t\theight: 9.5rem;\n\t}\n\t.item__title {\n\t\tfont-size: 1.25rem;\n\t}\n\t.item__text {\n\t\tfont-size: 0.9375rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contacts": `Contacts_contacts__bG7T6`,
	"contacts__block": `Contacts_contacts__block__U1fc2`,
	"list": `Contacts_list__3aoCp`,
	"list__item": `Contacts_list__item__Ch2GW`,
	"item__border": `Contacts_item__border__hO5P5`,
	"item__title": `Contacts_item__title__FaE8+`,
	"item__text": `Contacts_item__text__ZY7W2`
};
export default ___CSS_LOADER_EXPORT___;
